import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../firebase/AuthProvider';
import { createNewRoom } from '../../../services/videoService/VideoService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo, faPlus, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

// Mock data for scheduled meetings. In a real app, this would come from an API.
const scheduledMeetings = [
    { id: '1', title: 'Weekly Sync with Marketing', time: '10:00 AM', participants: 8 },
    { id: '2', title: 'Project Phoenix Kick-off', time: '2:00 PM', participants: 12 },
    { id: '3', title: '1-on-1 with Alex', time: '4:30 PM', participants: 2 },
];

const CreateMeetingPage = () => {
    const navigate = useNavigate();
    const { currentUser } = useAuth();

    const handleStartInstantMeeting = async () => {
        if (!currentUser) {
            alert('You must be logged in to create a meeting.');
            return;
        }
        try {
            const token = await currentUser.getIdToken();
            const { roomId } = await createNewRoom(token, 'Instant Meeting');
            // Navigate to the newly created video room
            navigate(`/lobby/${roomId}`);
        } catch (error) {
            console.error('Error creating instant meeting:', error);
            alert('Could not start a new meeting. Please try again.');
        }
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="card shadow-sm">
                        <div className="card-header bg-primary text-white">
                            <h2 className="mb-0 text-white">Video Meetings</h2>
                        </div>
                        <div className="card-body">
                            <p className="lead">Start an instant meeting or join a scheduled one.</p>
                            <button className="btn btn-lg btn-success w-100 mb-4" onClick={handleStartInstantMeeting}>
                                <FontAwesomeIcon icon={faPlus} className="me-2" />
                                Start Instant Meeting
                            </button>

                            <hr />

                            <h4 className="mt-4 mb-3 d-flex align-items-center">
                                <FontAwesomeIcon icon={faCalendarAlt} className="me-2" />
                                Today's Scheduled Meetings
                            </h4>
                            <ul className="list-group">
                                {scheduledMeetings.map(meeting => (
                                    <li key={meeting.id} className="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <h5 className="mb-1">{meeting.title}</h5>
                                            <small className="text-muted">{meeting.time} • {meeting.participants} participants</small>
                                        </div>
                                        <button className="btn btn-outline-primary">
                                            <FontAwesomeIcon icon={faVideo} className="me-2" />
                                            Join
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateMeetingPage;